import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import NavBarCustom from "../../components/NavBarCustom/NavBarCustom";
import { ScrollTop } from "../../components/ScrollTop/ScrollTop";
import Contact from "../../containers/Contact/Contact";
import Footer from "../../containers/Footer/Footer";
import Process from "../../containers/Process/Process";
import ServicesFull from "../../containers/ServicesFull/ServicesFull";

import "./ServicesPage.css";

const ServicesPage = (props) => {
	const { t } = useTranslation();
	const [serviceId, setServiceId] = useState("");
	const location = useLocation();

	useEffect(() => {
		if (location.state) {
			setServiceId(location.state.serviceId);
		}

		// Scroll to the top when the component mounts
		window.scrollTo(0, 0);
	}, [location.state]);

	return (
		<div className="team-page-container">
			{/* META TAGS */}
			<Helmet>
				<title>
					Servicios de diseño web, UX/UI y marketing digital | DevAcuarela
				</title>
				<meta
					name="description"
					content="Descubre nuestros servicios de desarrollo web, diseño UX/UI y marketing digital. Soluciones personalizadas para pymes y emprendedores que quieren crecer online."
				/>
			</Helmet>

			{/* PAGE CODE */}

			<div id="back-to-top-anchor"></div>

			<h2 className="title">{t("services.pageTitle")}</h2>

			<NavBarCustom actualRef={"services"} />
			<Process />
			<ServicesFull data={{ position: serviceId }} />
			<Contact />
			<Footer />

			<ScrollTop props={props} />
		</div>
	);
};

export default ServicesPage;
